import { setInfo } from '../setInfo'
import { UserDetailApi } from '../../api'
import { setActiveCategories } from 'SRC/modules/categories/actions'

export const fetchInfo = fields => async dispatch => {
  try {
    const username = fields.username
    const userSeo = typeof username === 'string' && username.length > 6 ? username : null

    const api = new UserDetailApi()
    const {user: {adsCategories: {categories}, ...rest}, error} = userSeo
      ? await api.getUserBySeo({ seo: userSeo })
      : await api.getUserByUsername(fields)

    if (rest && !error) {
      dispatch(setInfo(rest))
      if (Array.isArray(categories)) {
        dispatch(setActiveCategories(categories.map(item => item.id)))
      } else {
        dispatch(setActiveCategories([]))
      }
    } else {
      dispatch(setInfo(null))
      dispatch(setActiveCategories(null))
    }
  } catch (e) {
    dispatch(setInfo(null))
    dispatch(setActiveCategories(null))
  }
}
